var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5613 4.60321H13.473C10.0413 4.60321 7.08301 7.38488 7.08301 10.8182V28.6732C7.08301 32.2999 9.84801 35.1915 13.473 35.1915H26.788C30.2213 35.1915 33.003 32.1082 33.003 28.6732V13.3965L24.5613 4.60321Z",
    stroke: "#714FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1235 4.58371V9.43204C24.1235 11.7987 26.0385 13.7187 28.4035 13.7237C30.5985 13.7287 32.8435 13.7304 32.9952 13.7204",
    stroke: "#714FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0167 17.5H11.6167V23.3333H12.7V21.65H14.0167C15.55 21.65 16.5 20.8583 16.5 19.575C16.5 18.2833 15.55 17.5 14.0167 17.5ZM13.9667 20.7333H12.7V18.4167H13.9667C14.9167 18.4167 15.4084 18.8417 15.4084 19.575C15.4084 20.3083 14.9167 20.7333 13.9667 20.7333Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5819 23.3333H20.1319C22.0235 23.3333 23.3152 22.1667 23.3152 20.4167C23.3152 18.6667 22.0235 17.5 20.1319 17.5H17.5819V23.3333ZM18.6652 22.4167V18.4167H20.0819C21.3819 18.4167 22.2235 19.2083 22.2235 20.4167C22.2235 21.625 21.3819 22.4167 20.0819 22.4167H18.6652Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.725 18.4083V17.5H24.4666V23.3333H25.55V21.1H28.3666V20.1833H25.55V18.4083H28.725Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.06af57939b47a0803c6d028439b44b60.svg";
export { ForwardRef as ReactComponent };